export default __webpack_public_path__ + "static/media/015-socks.43ce4912.svg";